export default [
  {
    path: "revenues_pay",
    name: "Thông tin ngân sách",
    redirect: "/revenues_pay/summary",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "summary",
        name: "Quản lý Báo cáo Thu - Chi",
        component: () => import("@/views/screens/revenues_pay/summary"),
        meta: {
          requiresAuth: true,
          title: "Quản lý Báo cáo Thu - Chi"
        },
      },
      {
        path: "addrevenues",
        name: "Thu ngân sách",
        component: () => import("@/views/screens/revenues_pay/addrevenues"),
        meta: {
          requiresAuth: true,
          title: "Thêm BC thu ngân sách"
        },
      },
      {
        path: "editrevenues/:id",
        name: "Cập nhật BC Thu ngân sách",
        component: () => import("@/views/screens/revenues_pay/editRevenues"),
        meta: {
          requiresAuth: true,
          title: "Cập nhật BC Thu ngân sách"
        },
      },
      {
        path: "revenuesdetail/:id",
        name: "Chi tiết BC thu ngân sách",
        component: () => import("@/views/screens/revenues_pay/revenueDetail"),
        meta: {
          requiresAuth: true,
          title: "Chi tiết BC thu ngân sách"
        },
      },
      {
        path: "addpays",
        name: "Chi ngân sách",
        component: () => import("@/views/screens/revenues_pay/addpays"),
        meta: {
          requiresAuth: true,
          title: "Thêm BC Chi ngân sách"
        },
      },
      {
        path: "editpays/:id",
        name: "Cập nhật BC Chi ngân sách",
        component: () => import("@/views/screens/revenues_pay/editPay"),
        meta: {
          requiresAuth: true,
          title: "Cập nhật BC Chi ngân sách"
        },
      },
      {
        path: "paydetail/:id",
        name: "Chi tiết BC chi ngân sách",
        component: () => import("@/views/screens/revenues_pay/payDetail"),
        meta: {
          requiresAuth: true,
          title: "Chi tiết BC chi ngân sách"
        },
      },
    ],
  },
];
